import { currentCopilotSession as e } from "../global-state.js";
import { CopilotSession as t } from "../session.js";
import { atom as n } from "nanostores";
import { useCallback as r, useEffect as i, useState as a } from "react";
import { useStore as o } from "@nanostores/react";
//#region src/react/session.ts
var s = n(void 0), c = n(null);
function l(n) {
	let [o, s] = a(() => new t()), c = r(() => {
		let e = new t();
		return s(e), e;
	}, []);
	return i(() => {
		n?.isPrimary && e.set(o);
	}, [o, n?.isPrimary]), o.reset ?? Object.assign(o, { reset: c }), o;
}
function u() {
	return o(e);
}
function d(e) {
	return o(e?.__id ?? s);
}
function f(e) {
	return o(e?.__status ?? c);
}
function p(e) {
	return o(e.__statefulMessages);
}
function m(e) {
	return o(e.__tools);
}
function h(e) {
	return o(e.__meta);
}
function g(e) {
	return o(e.__queuedMessages);
}
function _(e) {
	return o(e.__restoredMessages);
}
function v(e) {
	return o(e.__lastTurnStopped);
}
function y(e) {
	return o(e.__enableWebSearch);
}
function b(e) {
	let t = o(e.__approvalMode);
	return o(e.__approvalModeAvailable) ? t : "ask";
}
//#endregion
export { b as useCopilotApprovalMode, m as useCopilotAvailableTools, v as useCopilotLastTurnStopped, p as useCopilotMessages, h as useCopilotMeta, g as useCopilotQueuedMessages, _ as useCopilotRestoredMessages, l as useCopilotSession, d as useCopilotSessionId, f as useCopilotStatus, y as useCopilotWebSearch, u as usePrimaryCopilotSession };
